// stripe.js
import { loadStripe } from "@stripe/stripe-js";

const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

if (!STRIPE_PUBLISHABLE_KEY && process.env.NODE_ENV !== "test") {
  console.error(
    "REACT_APP_STRIPE_PUBLISHABLE_KEY is not set — Add Card will not be able to load Stripe.js.",
  );
}

// Loaded once and reused everywhere Elements is mounted (Add Card today).
export const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY || "");

export default stripePromise;
